module.exports = __webpack_public_path__ + "static/media/IMG_2803.854ff69d.JPG";